import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=a1a21e26&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=ts"
export * from "./OrderList.vue?vue&type=script&lang=ts"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=a1a21e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a21e26",
  null
  
)

export default component.exports